import React from 'react';

const BuyNow = () => {
    return (
        <div>
            <div className="hero  bg-base-200">
  <div className="hero-content flex-col lg:flex-row-reverse">
    <img src="https://www.betterteam.com/images/gardener-job-description-2579x3868-20201121.jpeg?crop=1:1,smart&width=1200&dpr=2" className="max-w-sm rounded-lg shadow-2xl" />
    <div>
      <h1 className="text-5xl font-bold">Don't be late hesitating!</h1>
      <p className="py-6">Since we are providing you the most efficient and authentic tools for farming and gardening then you should't be late hesitating.</p>
      <button className="btn btn-primary">order now</button>
    </div>
  </div>
</div>
        </div>
    );
};

export default BuyNow;